// Referências externas
import React, { useEffect, useState, useRef } from 'react';
import { FiX, FiTrash2, FiExternalLink } from 'react-icons/fi';

// Referências internas
import { DynamicLoading } from '../../../common';
import api from '../../../services/api';
import { ToastContainer, toast } from 'react-toastify';

// Estilo
import './styles.css';

const permissaoUsuario = require('../../../services/permissaoUsuario');

export default function (props) {
    const mounted = useRef(false);
    // const [token, setToken] = useState({});
    const carregando = useRef(true); // ChatGPT
    const [anexo, setAnexo] = useState();
    const [nomeArquivo, setNomeArquivo] = useState();
    const [idArquivo, setIdArquivo] = useState();
    const [caminhoArquivo, setCaminhoArquivo] = useState();
    const [dataUpload, setDataUpload] = useState();
    
    const visualizarArquivo = () => {
        const url = `/api/hseq/acidente/anexo/download/${nomeArquivo}`;
        window.open(url, '_blank');
    };

    const excluirArquivo = async () => {
        if (!window.confirm("Tem certeza que deseja excluir este anexo?")) return;

        try {
            await api.delete(`/hseq/acidente/anexo/${nomeArquivo}`);
            
            // Atualiza a lista de anexos após exclusão
            const novosAnexos = props.anexos.filter(anexo => anexo.nome_arquivo !== nomeArquivo);
            props.setAnexos(novosAnexos);

            alert("Anexo excluído com sucesso.");
        } catch (err) {
            console.error(err);
            alert("Erro ao excluir o anexo.");
        }
    };


    useEffect(() => {
        if (!mounted.current) {
            if (carregando.current) {

                carregando.current = false;

            }
            mounted.current = true;
        }

    }, []);

    useEffect(() => {
        if (!carregando.current) {
        }

    }, []);


    useEffect(() => {
        setAnexo(props.anexoSelecionado)
        console.log(props.anexoSelecionado)
        setNomeArquivo(props.anexoSelecionado.nome_arquivo || props.anexoSelecionado.name);
        setCaminhoArquivo(props.anexoSelecionado.caminho_parcial);
        setDataUpload(props.anexoSelecionado.data_upload);        
    }, []);



    return (
        <div className="modal-fundo">
            <ToastContainer />

            <div className="modal-form-detalhes-anexo">
                <div className="modal-conteudo2">
                    <div className="modal-header">
                        <h2 className="wrapper-titulo">Detalhes do Anexo</h2>
                        <button className="botao-fechar-modal" onClick={() => {
                                props.fecharModal();
                         }} >
                            <FiX />
                        </button>
                    </div>


                    <p><strong>Nome:</strong> {nomeArquivo}</p>
                    {dataUpload && <p><strong>Data do Upload:</strong> {new Date(dataUpload).toLocaleString()}</p>}

                    <button className="visualizar-btn" onClick={visualizarArquivo}>
                        <FiExternalLink /> Visualizar
                    </button>

                    <button className="excluir-btn" onClick={excluirArquivo}>
                        <FiTrash2 /> Excluir
                    </button>




                </div>
            </div>
        </div>
    );
}